import React from 'react'
import { Stack } from '@sureco/design-system'
import styles from './PlanOverridesComponents.module.scss'

interface Props {
  recordCount: number
  recordLabel: string
  actionsSlot?: React.ReactNode
  subTabsSlot?: React.ReactNode
  toolbarSlot?: React.ReactNode
  searchSlot?: React.ReactNode
  contentSlot: React.ReactNode
  paginationSlot?: React.ReactNode
}

export default function OverrideTabLayout({
  recordCount,
  recordLabel,
  actionsSlot,
  subTabsSlot,
  toolbarSlot,
  searchSlot,
  contentSlot,
  paginationSlot,
}: Props) {
  return (
    <div className={styles.layout}>
      <Stack direction="row" space={16} className={styles.header}>
        <div>
          <div className={styles.title}>
            {recordLabel} ({recordCount} Records)
          </div>
        </div>
        {actionsSlot && (
          <Stack direction="row" space={8}>
            {actionsSlot}
          </Stack>
        )}
      </Stack>

      {subTabsSlot && <div className={styles.subTabs}>{subTabsSlot}</div>}

      {toolbarSlot && <div className={styles.toolbar}>{toolbarSlot}</div>}

      {searchSlot && <div className={styles.search}>{searchSlot}</div>}

      <div className={styles.content}>{contentSlot}</div>

      {paginationSlot && (
        <div className={styles.pagination}>{paginationSlot}</div>
      )}
    </div>
  )
}
